// NOTE: STRAIGHT FROM THE CHATGPT
import Image from '@tiptap/extension-image'
import {mergeAttributes} from '@tiptap/core'

export const ImageWithClass = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute('class'),
        renderHTML: (attributes) => {
          return {
            class: attributes.class,
          }
        },
      },
    }
  },

  parseHTML() {
    return [
      {tag: 'img[src^="data:image"]'}, // match base64 images explicitly
      {tag: 'img[src]'}, // match any other image
    ]
  },
})
